import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const types = {
    error: {
        className: 'alert-danger',
        icon: 'fa fa-ban',
        initialContent: `<p>Une erreur s'est produite, merci de réessayer ou de contacter un administrateur.</p>`,
        initialTitle: 'Oops !'
    },
    default: {
        className: 'bg-white',
        icon: 'fa fa-bell'
    },
    info: {
        className: 'alert-info',
        icon: 'fa fa-info'
    },
    success: {
        className: 'alert-success',
        icon: 'fa fa-check',
        initialContent: `<p>Everything went fine.</p>`,
        initialTitle: 'Succès !'
    },
    warning: {
        className: 'alert-warning',
        icon: 'fa fa-warning',
        initialTitle: 'Attention !'
    }
};

class Alert extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hidden: false,
            visible: true,
        };
    }
    componentDidMount() {
        setTimeout(() => this.setState({ visible: false}), 9000);
        setTimeout(() => this.setState({ hidden: true}), 9750);
    }
    render() {
        const { visible, hidden } = this.state;
        const { content, title, type } = this.props;
        const { className, icon, initialContent, initialTitle } = types[type];
        return (
            <div className={classNames(
                'alert alert-dismissible animated',
                className,
                {'slideInRight': visible},
                {'fadeOut': !visible},
                {'hidden': hidden}
            )}>
                <button type="button" className="close" data-dismiss="alert" aria-hidden="true">×</button>
                <h4><i className={classNames('icon', icon)}/> {title || initialTitle}</h4>
                <div dangerouslySetInnerHTML={{__html: content || initialContent}}/>
            </div>
        )
    }
}

Alert.propTypes = {
    content: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.string.isRequired
};

export default Alert;



// WEBPACK FOOTER //
// ./src/components/Alert/index.js